import React from "react";
import TechnicalSkills from "./components/TechnicalSkills";
import ProjectSection from "./components/ProjectSection";
import "./assets/css/blobz.min.css";
import projects from "./assets/data/projects";
import Education from "./components/Education";
import Experience from "./components/Experience";
import Achievements from "./components/Achievements";
import HeroSection from "./components/HeroSection";
import NavigationBar from "./components/NavigationBar";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="flex flex-col items-center min-h-screen bg-white dark:bg-gray-900 ">
      <NavigationBar />
      <HeroSection />
      <TechnicalSkills />
      <ProjectSection projects={projects} />
      <Education />
      <Experience />
      <Achievements />
      <Footer />
    </div>
  );
}

export default App;
